export enum OrganizerType {
    CREATOR = "CREATOR",
    ORGANIZER = "ORGANIZER",
    RESPONSIBLE = "RESPONSIBLE",
}

export type Organizer = {
    email?: string
    name?: string
    phone?: string
    id?: number
    type?: OrganizerType
    organizerType?: OrganizerType
}
